import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const InformationCard = ({ icon, title, description }) => {
  return (
    <div className="flex w-full flex-col items-center gap-5">
      <Icon icon={icon} size={120} />
      <div className="flex max-w-[460px] flex-col items-center gap-2 text-center">
        <Typography
          variant="h3"
          weight="semibold"
          color="neutral-900"
          className="!text-2xl sm:!text-xl">
          {title}
        </Typography>
        {description && (
          <Typography variant="p" size="medium" color="neutral-600" className="!text-base">
            {description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default InformationCard;
